import { FORM_VALIDATED } from "./consts";
import * as stateReducer from './handleInputState';
const StateReducer = stateReducer.StateReducer;


/**
 * 
 * @param {{
 * showPassword: boolean,
 * showAdditionalMessage: boolean,
 * password: string | null,
 * rules: ('minLength' | 'hasUpperCaseCharacter' | 'hasLowerCaseCharacter' | 'hasNumber' | 'hasSymbol' | 'hasNumber' )[],
 * failedValidationMessage: string,
 * passwordRequiredMessage: string,
 * serverMessage: string,
 * input: any
 * }} data
 * 
 * 
*/
export const PasswordInputFieldData = (data) => ({
    showPassword: data.showPassword,
    showAdditionalMessage: data.showAdditionalMessage,
    password: data.password,
    rules: data.rules,
    failedValidationMessage: data.failedValidationMessage,
    passwordRequiredMessage: data.passwordRequiredMessage,
    serverMessage: data.serverMessage,
    hasServerMessage: data.serverMessage !== '',
    message: data.serverMessage,
    /**
     * @type HTMLInputElement | null
    */
    inputref: null,
    /**
     * @type {stateReducer.inputState}
     */
    state: { interactionState: 'not-interacted', validationState: 'valid' },
    init() {
        this.inputref = this.$refs.inputref;
        if (this.hasServerMessage) {
            this.inputref.classList.toggle('input-touched', true);
            this.state = StateReducer(this.state, { type: 'server-error' });
            this.inputref.setCustomValidity(this.serverMessage);
            this.message = this.serverMessage;
        } else {
            this.setValidation(this.validateRules());
        }

        this.inputref?.addEventListener('focus', () => {
            this.showAdditionalMessage = true; // Note: Once shown, we will keep it visible to avoid additional layout shift
        })

        this.inputref?.addEventListener('blur', () => {
            this.setValidation(this.validateRules());
            this.state = StateReducer(this.state, { type: 'blur', validationState: this.inputref.checkValidity() ? 'valid' : 'invalid' });
        })

        this.$watch('password', (newVal) => {
            if (this.hasServerMessage && this.message === this.serverMessage) {
                this.inputref.setCustomValidity('');
            }
            this.setValidation(this.validateRules());
            this.state = StateReducer(this.state, { type: 'input', validationState: this.inputref.checkValidity() ? 'valid' : 'invalid' });
        })

        this.$watch(FORM_VALIDATED, () => {
            this.setValidation(this.validateRules());
            this.state = StateReducer(this.state, { type: 'form-validated', validationState: this.inputref.checkValidity() ? 'valid' : 'invalid' });
        });

        this.$watch('state',
            /**
             * @param {stateReducer.inputState} state 
             */
            (state) => {
                this.inputref.classList.toggle('input-touched',
                    state.interactionState === 'interacted'
                );
                
                const validationMessage = this.password.length === 0 ? this.passwordRequiredMessage : this.failedValidationMessage;

                if (this.state.interactionState === 'interacted' && this.state.validationState === 'invalid') {
                    this.message = validationMessage;
                    this.inputref.setAttribute('aria-invalid', 'true');
                } else {
                    this.message = '';
                    this.inputref.setAttribute('aria-invalid', 'false');
                }
            })
    },
    validateRules() {
        for (const rule of this.rules) {
            switch (rule) {
                case 'minLength':
                    if (!this.isValidLength()) {
                        return false;
                    }
                    break;
                case 'validNewPasswordLength':
                    if (!this.isValidNewPasswordLength()) {
                        return false;
                    }
                    break;
                case 'hasUpperCaseCharacter':
                    if (!this.hasUpperCaseCharacters()) {
                        return false;
                    }
                    break;
                case 'hasLowerCaseCharacter':
                    if (!this.hasLowerCaseCharacters()) {
                        return false;
                    }
                    break;
                case 'hasNumber':
                    if (!this.hasNumber()) {
                        return false;
                    }
                    break;
                case 'hasSymbol':
                    if (!this.hasSymbol()) {
                        return false;
                    }
                    break;
                default:
                    console.error('Invalid Rule ', rule)
                    return false;
            }
        }
        return true;
    },
    isValidLength() {
        return this.password.length >= 1;
    },
    isValidNewPasswordLength() {
        return this.password.length >= 12;
    },
    hasUpperCaseCharacters() {
        return /[A-Z]/.exec(this.password);
    },
    hasLowerCaseCharacters() {
        return /[a-z]/.exec(this.password);
    },
    hasNumber() {
        return /[0-9]/.exec(this.password);
    },
    hasSymbol() {
        return /\W/.exec(this.password);
    },
    /**
     * 
     * @param {boolean} isValid 
     */
    async setValidation(isValid) {
        if (this.inputref) {
            if (!isValid) {
                if (this.password.length === 0) {
                    this.inputref.setCustomValidity(this.passwordRequiredMessage);
                } else {
                    this.inputref.setCustomValidity(this.failedValidationMessage);
                }
            }
            else {
                this.inputref.setCustomValidity("");
            }
        }
    }
})